exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".colorButton,.colorButton:focus{background-color:#0B5BAC;border:1px solid #0B5BAC;color:#fff;font-weight:bold}.colorButton:hover{background-color:#0d70d3;border:1px solid #0f6fcf;color:#fff;font-weight:bold}.el-submenu .el-submenu__icon-arrow{color:black}\n", ""]);

// exports
